<template>
  <div
    class="collection-grid-header"
    v-if="$mq !== 'mobile' && $mq !== 'tablet'"
  >
    <div class="collection-grid-header__sort-pagination-total-wrapper">
      <collection-total-results></collection-total-results>
      <collection-active-filters-b></collection-active-filters-b>
      <collection-sorting
        class="sorting"
        :default-sort="defaultSort"
        :value="currentSort"
      ></collection-sorting>
      <div class="collection-grid-selections">
        <div
          class="collection-grid-selections__option"
          @click="changeGridColumns('collection-grid-columns--4'); gridSelectionDesktop = 4"
          :class="{ active : gridSelectionDesktop === 4}"
        >
          <icon name="grid-columns-4" size="26px"></icon>
        </div>
        <div
          class="collection-grid-selections__option"
          @click="changeGridColumns('collection-grid-columns--3'); gridSelectionDesktop = 3"
          :class="{ active : gridSelectionDesktop === 3}"
        >
          <icon name="grid-columns-3" size="26px"></icon>
        </div>
      </div>
    </div>
  </div>
  <div class="collection-grid-header__mobile" v-else>
    <portal to="collection__mobile-menu">
      <div class="collection-grid-header__mobile-menu">
        <div class="collection-grid-sort-filter" @click="toggleMobileSortingMenu">
          Filter/Sort +
        </div>
        <div
          v-if="$mq === 'mobile'"
          class="collection-grid-selections__option"
          @click="changeGridColumns('collection-grid-columns--1'); gridSelectionMobile = 1"
          :class="{ active : gridSelectionMobile === 1}"
        >
          <icon name="grid-columns-1" size="18px"></icon>
        </div>
        <div
          v-if="$mq === 'mobile'"
          class="collection-grid-selections__option"
          @click="changeGridColumns('collection-grid-columns--2'); gridSelectionMobile = 2"
          :class="{ active : gridSelectionMobile === 2}"
        >
          <icon name="grid-columns-2" size="18px"></icon>
        </div>
      </div>
    </portal>
    <div class="collection-grid-header__mobile-menu-results-wrapper">
      <collection-total-results></collection-total-results>
    </div>
    <collection-mobile-menu-b
      :menu-active="mobileSortingMenuActive"
      :close-binding="toggleMobileSortingMenu"
      :enable-apply-button="true"
      :enable-clear-all="true"
      menu-title="Filter/Sort"
    >
      <collection-active-filters-b></collection-active-filters-b>
      <collection-accordion-b
        iconSize="14px"
        activeIcon="minus"
        inactiveIcon="plus"
        heading="Sort by"
        class="sort-mobile-menu"
      >
        <collection-sorting
          :default-sort="defaultSort"
          :mobile-click-binding="toggleMobileSortingMenu"
        ></collection-sorting>
      </collection-accordion-b>
      <collection-filters-b
        class="collection-grid__filters"
        :tags="tags"
        :filters="filters"
      ></collection-filters-b>
    </collection-mobile-menu-b>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Icon from '@/scripts/components/basic/Icon.vue'
import Accordion from '../basic/Accordion.vue'
import VLink from '../buttons/VLink.vue'
import VButton from '../buttons/VButton.vue'
import CollectionTotalResults from '@/scripts/components/collection/CollectionTotalResults.vue'
import CollectionPaginationControlsB from '@/scripts/components/collection/CollectionPaginationControlsB.vue'
import CollectionFiltersB from '@/scripts/components/collection/CollectionFiltersB.vue'
import CollectionSorting from '@/scripts/components/collection/CollectionSorting.vue'
import CollectionMobileMenuB from '@/scripts/components/collection/CollectionMobileMenuB.vue'
import { unhandleize } from '../../filters/string.js'
import CollectionActiveFiltersB from '@/scripts/components/collection/CollectionActiveFiltersB'
import CollectionAccordionB from '@/scripts/components/collection/CollectionAccordionB'
import { Portal } from 'portal-vue';

export default {
  name: 'CollectionGridHeaderB',
  components: {
    Icon,
    Accordion,
    VLink,
    VButton,
    CollectionTotalResults,
    CollectionPaginationControlsB,
    CollectionFiltersB,
    CollectionSorting,
    CollectionMobileMenuB,
    CollectionActiveFiltersB,
    CollectionAccordionB,
    Portal
  },
  props: {
    paginationAmount: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    tags: {
      type: Array,
      required: true
    },
    filters: {
      type: Array,
      required: true
    },
    defaultSort: {
      type: String,
      required: true
    },
    filtersDisabled: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      mobileFiltersMenuActive: false,
      mobileSortingMenuActive: false,
      gridSelectionMobile: 2,
      gridSelectionDesktop: 4,
    }
  },
  computed: {
    ...mapState({
      currentSort: state => state.collections.currentSort,
    })
  },
  methods: {
    toggleMobileFiltersMenu () {
      this.mobileFiltersMenuActive = !this.mobileFiltersMenuActive
    },
    toggleMobileSortingMenu () {
      const productGridPosition = document.getElementById('shopify-section-collection-grid').offsetTop;
      window.scrollTo({top: productGridPosition - 90, behavior:'smooth'});
      this.mobileSortingMenuActive = !this.mobileSortingMenuActive
    },
    unhandleizeTitle (handleizedFilter) {
      return unhandleize(handleizedFilter)
    },
    changeGridColumns (gridClass) {
      this.$emit('changeGridColumns', gridClass)
    }
  },
  created () {
    this.$emit('changeGridColumns', 'collection-grid-columns--4');
  }
}
</script>

<style scoped lang="scss">
.collection-grid-header {
  position: relative;
  padding: 12px 0;

  &__sort-pagination-total-wrapper {
    display: flex;
    align-items: center;
    .collection-sorting {
      margin-left: auto;
      margin-right: 29px;
    }
  }
  &__pagination-with-total {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 16px;
    .sorting {
      margin-right: 20px;
    }
  }
  &__mobile {
    width: 100%;
    padding-top: 8px;
    // position: sticky;
    // top: 84px;
    &-menu {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      margin: 0 -2px;
      button {
        margin: 8px 2px;
      }
      &-results-wrapper {
        // border-bottom: 1px solid $color-light-grey;
        width: 100%;
        padding: 16px 0;
      }
    }
  }
}
.collection-mobile-accordion {
  min-width: 204px;
  &__global-menu {
    display: flex;
    flex-direction: column;
    padding: 24px 0 16px;
    .top-level {
      border-bottom: 1px solid $color-grey;
      padding: 12px 0 6px;
      font-weight: 600;
      color: $color-black;
    }
    .collection-mobile-accordion__custom-menu-item {
      color: $color-black;
      font-size: 12px;
      font-family: $font-family-primary;
    }

    > a:visited {
      color: $color-black;
    }
  }
}
.remove-bottom-spacing {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}
/deep/ .accordion__menu-title {
  font-family: $font-family-primary;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  line-height: 20px;
}

.collection-grid-sort-filter {
  height: 45px;
  line-height: 45px;
  background-color: $collection-filter-bg;
  padding-left: 14px;
  padding-right: 14px;
  margin-right: 1px;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  font-size: 14px;
  color: $color-black-900;
  cursor: pointer;
}

.collection-grid-selections {
  display: flex;
  flex-direction: row;
  &__option {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 45px;
    height: 45px;
    background-color: $collection-filter-bg;
    cursor: pointer;

    svg {
      opacity: 0.4;
    }

    &.active {
      position: relative;
      svg {
        opacity: 1;
      }
      &:after {
        content: "";
        display: block;
        width: 100%;
        height: 1px;
        position: absolute;
        bottom: 0;
        left: 0;
        background: $color-black-900;
      }
    }

    &:not(:last-child) {
      margin-right: 1px;

      @include desktop-up {
        margin-right: 8px;
      }
    }
  }
}

.sort-mobile-menu {
  padding-left: 16px;
  padding-right: 7px;
}
</style>
